<template>
  <div class="meter-box container lib__no-padding row">
    <div :class="'col-xs-12 col-sm-12 col-md-12 col-lg-12 lib__no-margin lib__no-padding'">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row meter-box top-text-container">
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 meter-box title">
          {{ title }}
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 row meter-box price-container">
          <div v-if="!isFree && !isPriceToBeDetermined"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row lib__no-margin lib__no-padding">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price">
              {{ excludingVatPrice }}€
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price-info">
              {{ $t('meter-box.excludingVat') }}
            </div>
          </div>
          <div v-if="isPriceToBeDetermined && !isFree"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row lib__no-margin lib__no-padding">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price-free">
              {{ $t('new-connection-cmh.offering-selection-step.priceToBeEstimated') }}
            </div>
          </div>
          <div v-if="isFree && !isPriceToBeDetermined"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row lib__no-margin lib__no-padding">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price-free">
              {{ $t('new-connection-cmh.offering-selection-step.free') }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row meter-box bottom-text-container">
        <div v-if="description" :class="readonly ? 'meterbox readonly description-margin' : ''"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box description">
          {{ description }}
        </div>
      </div>
    </div>
    <div v-if="!readonly" class="col-xs-12 col-md-12 col-sm-12 col-lg-12 lib__no-padding lib__no-margin">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 button-container">
        <nav class="lib__btns-list">
          <button @click="onEdit(identifier)" type="button" class="lib__btn lib__btn--link lib__btn--secondary">
            <i class="fa fa-pencil-alt"></i>
            <span>{{ $t('meter-box.edit') }}</span>
          </button>

          <button @click="onDelete(identifier)" type="button" class="lib__btn lib__btn--link lib__btn--danger">
            <i class="fa fa-trash-alt"></i>
            <span>{{ $t('meter-box.delete') }}</span>
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'meter-editable-box'
})
export default class MeterEditableBox extends Vue {
  @Prop({ type: Number, required: true }) public identifier!: number
  @Prop({ type: String, required: true }) public title!: string
  @Prop({ type: String, required: false, default: '0' }) public excludingVatPrice!: string
  @Prop({ type: String, required: true }) public description!: string
  @Prop({ type: Function, required: true }) public onEdit!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public onDelete!: (identifier: number) => void
  @Prop({ type: Boolean, required: false, default: false }) public readonly!: boolean
  @Prop({ type: Boolean, required: true }) public isPriceToBeDetermined!: boolean

  public isFree: boolean = false

  public mounted() {
    this.isFree = this.excludingVatPrice === '0'
  }
}
</script>

<style scoped>
.meter-box.container {
  box-sizing: border-box;
  border: 1px solid #c1c7cc;
  border-radius: 4px;
  margin: 20px auto;
}

.button-container {
  margin: 20px 0 20px;
}

.button-container .lib__btns-list {
  justify-content: center;
}

.button-container .lib__btns-list .lib__btn+.lib__btn {
  margin-left: 30px;
}

@media screen and (min-width: 577px) {
  .meter-box.title {
    height: 40px;
    width: 200px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.top-text-container {
    margin: 10px 0px 0px;
  }

  .meter-box.price {
    height: 16px;
    width: 36px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-info {
    height: 18px;
    width: 49px;
    color: #232121;
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-free {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-container {
    padding: 0px;
  }

  .meter-box.bottom-text-container {
    margin: 0px 0px 10px;
  }

  .meter-box.description {
    height: 18px;
    width: 260px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.button-container {
    margin: 0px 0px 20px;
    text-align: center;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    height: 100%;
  }

  .fa {
    margin-top: -4px;
  }

  .meter-box.edit {
    color: #0096ce;
  }

  .meter-box.delete {
    color: #e63323;
  }

  .meter-box.action-container {
    margin: auto;
    height: 50%;
    width: 100%;
    cursor: pointer;
  }
}

@media screen and (max-width: 576px) {
  .meter-box.title {
    width: 100%;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.top-text-container {
    margin: 20px 0px 0px;
  }

  .meter-box.price {
    height: 16px;
    width: 36px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-info {
    height: 18px;
    width: 49px;
    color: #232121;
    font-family: 'Open Sans';
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-free {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-container {
    padding: 0px;
  }

  .meter-box.bottom-text-container {
    margin: 10px 0px 0px;
  }

  .meter-box.description {
    height: 18px;
    width: 260px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.button-container {
    margin: 10px 0px 10px;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
  }

  .fa {
    margin-top: -4px;
  }

  .meter-box.edit {
    color: #0096ce;
  }

  .meter-box.delete {
    color: #e63323;
  }

  .meter-box.readonly.description-margin {
    margin-bottom: 20px;
  }
}</style>
